import { useEffect, useState } from "react";
import { FaBridgeCircleCheck } from "react-icons/fa6";
import { IoPerson } from "react-icons/io5";
import { MdKeyboardDoubleArrowLeft, MdOutlineArchitecture } from "react-icons/md";
import { RiMapPinRangeFill } from "react-icons/ri";
import { SiTestrail } from "react-icons/si";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { notify, Toast } from "../../common/Toast/index.js";
import FormFields from "../../common/FormFields/index.js";
import { FaStarOfLife } from "react-icons/fa";
import { getEntityFields, getSaveUrl } from "../../utlis/entityConfig.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const Details = ({ isModelOpen }) => {
  const permission = getUserMenuPermission(7);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOwnerData, setIsOwnerData] = useState([]);
  const [isArchitectData, setIsArchitectData] = useState([]);
  const [isFabricatorData, setIsFabricatorData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEntityType, setCurrentEntityType] = useState(null);
  const [isSalePersonData, setIsSalePersonData] = useState([]);
  const { siteData, isReadOnly } = location.state || {};
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Site_Id: "",
    Site_Name: "",
    Site_Type: "",
    address: "",
    location_Link: "",
    sale_Person_Id: "",
    Remark: "",
    mobile_No: "",
    Owner_ID: "",
    owner_Name: "",
    ownerContact: "",
    ownerEmail: "",
    ownerAddress: "",
    ownerFirm: "",
    Architect_ID: "",
    architect_Name: "",
    architectContact: "",
    architectEmail: "",
    architectAddress: "",
    architectFirm: "",
    Fabricator_ID: "",
    febricator_Name: "",
    fabricatorContact: "",
    fabricatorEmail: "",
    fabricatorAddress: "",
    fabricatorFirm: "",
  });
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    fetchData();
    fetchSalePerson();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Site_Name.trim()) {
      newErrors.Site_Name = "Site Name is required";
    }
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }
    if (!formData.sale_Person_Id) {
      newErrors.sale_Person_Id = "Sale Person is required";
    }
    if (!formData.mobile_No) {
      newErrors.mobile_No = "Contact No is required";
    } else if (!/^\d{10}$/.test(formData.mobile_No)) {
      newErrors.mobile_No = "Invalid contact number (must be 10 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchData = async () => {
    try {
      const [ownerRes, architectRes, fabricatorRes] = await Promise.all([
        axiosInstance.get("Owner/GetAll"),
        axiosInstance.get("Architect/GetAll"),
        axiosInstance.get("Fabricator/GetAll"),
      ]);
      setIsOwnerData(ownerRes.data);
      setIsArchitectData(architectRes.data);
      setIsFabricatorData(fabricatorRes.data);
    } catch (error) {
      notify("Error fetching data:", error);
      setIsOwnerData([]);
      setIsArchitectData([]);
      setIsFabricatorData([]);
    }
  };

  const handleInputChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({
        ...prev,
        id: e ? e.value : "",
      }));
    }
  };

  useEffect(() => {
    const fetchEntityDetails = async () => {
      try {
        if (siteData.owner_Id) {
          const res = await axiosInstance.get(
            `Owner/GetById/${siteData.owner_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            ownerContact: data.contact_No,
            ownerEmail: data.email_ID,
            ownerAddress: data.office_Address,
            ownerFirm: data.firm_Name,
          }));
        }
        if (siteData.architect_Id) {
          const res = await axiosInstance.get(
            `Architect/GetById/${siteData.architect_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            architectContact: data.contact_No,
            architectEmail: data.email_ID,
            architectAddress: data.office_Address,
            architectFirm: data.firm_Name,
          }));
        }
        if (siteData.fabricator_Id) {
          const res = await axiosInstance.get(
            `Fabricator/GetById/${siteData.fabricator_Id}`
          );
          const data = res.data;
          setFormData((prev) => ({
            ...prev,
            fabricatorContact: data.contact_No,
            fabricatorEmail: data.email_ID,
            fabricatorAddress: data.office_Address,
            fabricatorFirm: data.firm_Name,
          }));
        }
      } catch (error) {
        console.error("Error fetching details by ID", error);
      }
    };

    if (siteData) {
      setIsEditing(true);
      setFormData({
        Site_Id: siteData.site_Id || "",
        Site_Name: siteData.site_Name || "",
        Site_Type: siteData.site_Type || "",
        address: siteData.address || "",
        location_Link: siteData.location_Link || "",
        sale_Person_Id: siteData.sale_Person_Id || "",
        Remark: siteData.Remark || "",
        mobile_No: siteData.mobile_No || "",
        Owner_ID: siteData.owner_Id || "",
        Architect_ID: siteData.architect_Id || "",
        Fabricator_ID: siteData.fabricator_Id || "",
      });
      fetchEntityDetails();
    } else {
      setIsEditing(false);
      setFormData({
        Site_Name: "",
        Site_Type: "",
        address: "",
        location_Link: "",
        sale_Person_Id: "",
        Remark: "",
        mobile_No: "",
        Owner_ID: "",
        Architect_ID: "",
        Fabricator_ID: "",
      });
    }
  }, [siteData]);

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    if (!isEditing && !permission.isInsert) return;
    if (isEditing && !permission.isUpdate) return;
    const payload = {
      Site_Id: formData.Site_Id,
      Site_Name: formData.Site_Name,
      Site_Type: formData.Site_Type,
      Address: formData.address,
      Location_Link: formData.location_Link,
      sale_Person_Id: formData.sale_Person_Id
        ? Number(formData.sale_Person_Id)
        : null,
      Remark: formData.Remark,
      Mobile_No: formData.mobile_No,
      Owner_ID:
        formData.Owner_ID && !isNaN(Number(formData.Owner_ID))
          ? Number(formData.Owner_ID)
          : null,
      Architect_ID:
        formData.Architect_ID && !isNaN(Number(formData.Architect_ID))
          ? Number(formData.Architect_ID)
          : null,
      Fabricator_ID:
        formData.Fabricator_ID && !isNaN(Number(formData.Fabricator_ID))
          ? Number(formData.Fabricator_ID)
          : null,
      Created_By: userId,
      UpdatedBy: userId,
    };

    try {
      const response = await axiosInstance.post(
        "SiteDetail/InsertUpdate",
        payload
      );

      if (response.data) {
        notify(
          isEditing
            ? "SiteDetail updated successfully!"
            : "SiteDetail added successfully!",
          "success"
        );
        setTimeout(() => navigate("/transaction/sites"), 1000);
      } else {
        notify("Something went wrong. Please try again.");
      }
    } catch (error) {
      notify("Error saving site:", error);
      notify(
        `Failed to save site. Error: ${error.response?.data?.message || error.message
        }`
      );
    }
  };
  const capitalize = (s) => s && s.charAt(0).toUpperCase() + s.slice(1);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...(currentEntityType && {
        [`${currentEntityType}_Name`]: formData.name,
        contact_No: formData.contactNo,
        email_ID: formData.email,
        firm_Name: formData.firmName,
        office_Address: formData.officeAddress,
      }),
    };

    const url = getSaveUrl(currentEntityType);

    try {
      await axiosInstance.post(url, payload);

      await fetchData();
      const latestList =
        currentEntityType === "owner"
          ? isOwnerData
          : currentEntityType === "architect"
            ? isArchitectData
            : isFabricatorData;

      const addedItem = latestList.find(
        (item) => item[`${currentEntityType}_Name`] === formData.name
      );

      // Create updated fields for formData
      const updatedFields = {
        [`${capitalize(currentEntityType)}_ID`]:
          addedItem?.[`${currentEntityType}_ID`] || "",
      };

      if (currentEntityType === "owner") {
        updatedFields.ownerContact = addedItem?.contact_No || "";
        updatedFields.ownerEmail = addedItem?.email_ID || "";
        updatedFields.ownerAddress = addedItem?.office_Address || "";
        updatedFields.ownerFirm = addedItem?.firm_Name || "";
      } else if (currentEntityType === "architect") {
        updatedFields.architectContact = addedItem?.contact_No || "";
        updatedFields.architectEmail = addedItem?.email_ID || "";
        updatedFields.architectAddress = addedItem?.office_Address || "";
        updatedFields.architectFirm = addedItem?.firm_Name || "";
      } else if (currentEntityType === "fabricator") {
        updatedFields.fabricatorContact = addedItem?.contact_No || "";
        updatedFields.fabricatorEmail = addedItem?.email_ID || "";
        updatedFields.fabricatorAddress = addedItem?.office_Address || "";
        updatedFields.fabricatorFirm = addedItem?.firm_Name || "";
      }
      setFormData((prev) => ({
        ...prev,
        ...updatedFields,
      }));

      setIsModalOpen(false);
    } catch (error) {
      notify("Error saving data:", error);
    }
  };
  const clearModalFormData = () => {
    setFormData((prev) => ({
      ...prev,
      name: "",
      contactNo: "",
      email: "",
      firmName: "",
      officeAddress: "",
    }));
  };

  const fetchSalePerson = async () => {
    try {
      const res = await axiosInstance.get(`User/GetAllUser`);
      setIsSalePersonData(res.data);
    } catch (error) {
      notify("Error fetching Account Groups:", error);
    }
  };
  const options = [
    ...(Array.isArray(isSalePersonData) ? isSalePersonData : []).map(
      (person) => ({
        value: person.sale_Person_Id?.toString() || "",
        label: person.Sale_Person_Name || "Unnamed Site",
      })
    ),
  ];
  const ownerOptions = [
    ...(Array.isArray(isOwnerData) ? isOwnerData : []).map((owner) => ({
      value: owner.owner_ID?.toString() || "",
      label: owner.owner_Name || "Unnamed Owner",
    })),
    { value: "add-new", label: "+ Add New Owner" },
  ];
  const architectOptions = [
    ...(Array.isArray(isArchitectData) ? isArchitectData : []).map(
      (architect) => ({
        value: architect.architect_ID?.toString() || "",
        label: architect.architect_Name || "Unnamed Architect",
      })
    ),
    { value: "add-new", label: "+ Add New Architect" },
  ];
  const fabricatorOptions = [
    ...(Array.isArray(isFabricatorData) ? isFabricatorData : []).map(
      (fabricator) => ({
        value: fabricator.fabricator_ID?.toString() || "",
        label: fabricator.fabricator_Name || "Unnamed Site",
      })
    ),
    { value: "add-new", label: "+ Add New Fabricator" },
  ];
  const siteTypeOptions = [
    { value: "project", label: "Project" },
    { value: "bunglow", label: "Bungalow" },
  ];
  const handleEntityChange = (selectedOption, type, entityList) => {
    if (!selectedOption) {
      setFormData((prev) => ({
        ...prev,
        [`${capitalize(type)}_ID`]: "",
        ...(type === "owner"
          ? {
            ownerContact: "",
            ownerEmail: "",
            ownerAddress: "",
            ownerFirm: "",
          }
          : type === "architect"
            ? {
              architectContact: "",
              architectEmail: "",
              architectAddress: "",
              architectFirm: "",
            }
            : {
              fabricatorContact: "",
              fabricatorEmail: "",
              fabricatorAddress: "",
              fabricatorFirm: "",
            }),
      }));
      return;
    }

    if (selectedOption.value === "add-new") {
      setCurrentEntityType(type);
      clearModalFormData();
      setIsModalOpen(true);
      return;
    }

    const selected = entityList.find(
      (item) => String(item[`${type}_ID`]) === selectedOption.value
    );

    const updatedFields = {
      [`${capitalize(type)}_ID`]: selectedOption.value,
    };

    if (type === "owner") {
      updatedFields.ownerContact = selected?.contact_No || "";
      updatedFields.ownerEmail = selected?.email_ID || "";
      updatedFields.ownerAddress = selected?.office_Address || "";
      updatedFields.ownerFirm = selected?.firm_Name || "";
    } else if (type === "architect") {
      updatedFields.architectContact = selected?.contact_No || "";
      updatedFields.architectEmail = selected?.email_ID || "";
      updatedFields.architectAddress = selected?.office_Address || "";
      updatedFields.architectFirm = selected?.firm_Name || "";
    } else if (type === "fabricator") {
      updatedFields.fabricatorContact = selected?.contact_No || "";
      updatedFields.fabricatorEmail = selected?.email_ID || "";
      updatedFields.fabricatorAddress = selected?.office_Address || "";
      updatedFields.fabricatorFirm = selected?.firm_Name || "";
    }

    setFormData((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  };

  return (
    <>
      <Toast />
      <div className="max-w-[1600px] mx-auto pb-10">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-8 px-2">
          <div className="flex flex-col">
            <h1 className="text-2xl font-black text-slate-800 tracking-tight flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center text-primary">
                <SiTestrail className="text-[22px]" />
              </div>
              {isEditing ? "Edit Site Details" : "Create New Site"}
            </h1>
            <p className="text-sm font-medium text-slate-400 mt-1 ml-13">
              {isEditing ? "Update existing site information and stakeholders" : "Register a new project site and assign key contacts"}
            </p>
          </div>
          <button
            className="group flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-200 text-slate-600 font-bold text-sm rounded-xl hover:bg-slate-50 hover:text-slate-900 transition-all shadow-sm"
            onClick={() => navigate(`/transaction/sites`)}
          >
            <MdKeyboardDoubleArrowLeft className="text-lg group-hover:-translate-x-1 transition-transform" />
            Back to List
          </button>
        </div>

        <form onSubmit={onHandleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-8">

            {/* Left Column: Primary Site Info */}
            <div className="xl:col-span-12">
              <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 overflow-hidden">
                <div className="px-8 py-5 border-b border-slate-50 bg-slate-50/50 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center text-white shadow-lg shadow-blue-500/20">
                      <SiTestrail className="text-lg" />
                    </div>
                    <h2 className="text-[15px] font-black text-slate-800 uppercase tracking-wider">Primary Site Information</h2>
                  </div>
                  {!isReadOnly && (
                    <span className="text-[10px] font-bold bg-amber-100 text-amber-700 px-2.5 py-1 rounded-full uppercase tracking-widest">Required Fields *</span>
                  )}
                </div>

                <div className="p-8">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Site Name */}
                    <div className="space-y-2">
                      <label className="text-[13px] font-bold text-slate-700 flex items-center gap-1">
                        Site Name <span className="text-red-500 text-[10px]">*</span>
                      </label>
                      <div className="relative group">
                        <input
                          type="text"
                          name="Site_Name"
                          value={formData.Site_Name}
                          onChange={handleInputChange}
                          placeholder="e.g. Royal residency Phase 1"
                          disabled={isReadOnly}
                          className={`w-full bg-slate-50 border-2 rounded-2xl px-5 py-3 text-[14px] font-medium transition-all outline-none ${errors.Site_Name
                            ? "border-red-100 focus:border-red-400 focus:ring-4 focus:ring-red-50"
                            : "border-slate-50 focus:border-primary/30 focus:bg-white focus:ring-4 focus:ring-primary/5"
                            }`}
                        />
                        {errors.Site_Name && (
                          <p className="text-[11px] font-bold text-red-500 mt-1.5 ml-1">{errors.Site_Name}</p>
                        )}
                      </div>
                    </div>

                    {/* Site Type */}
                    <div className="space-y-2">
                      <label className="text-[13px] font-bold text-slate-700">Site Category</label>
                      <Select
                        name="Site_Type"
                        isSearchable={false}
                        options={siteTypeOptions}
                        value={siteTypeOptions.find(option => option.value === formData.Site_Type)}
                        onChange={(opt) => handleInputChange({ target: { name: "Site_Type", value: opt?.value || "" } })}
                        isDisabled={isReadOnly}
                        placeholder="Select type..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={customSelectStyles}
                      />
                    </div>

                    {/* Contact No */}
                    <div className="space-y-2">
                      <label className="text-[13px] font-bold text-slate-700 flex items-center gap-1">
                        Contact Number <span className="text-red-500 text-[10px]">*</span>
                      </label>
                      <div className="relative group">
                        <input
                          type="text"
                          name="mobile_No"
                          value={formData.mobile_No}
                          onChange={handleInputChange}
                          placeholder="10-digit mobile number"
                          disabled={isReadOnly}
                          className={`w-full bg-slate-50 border-2 rounded-2xl px-5 py-3 text-[14px] font-medium transition-all outline-none ${errors.mobile_No
                            ? "border-red-100 focus:border-red-400 focus:ring-4 focus:ring-red-50"
                            : "border-slate-50 focus:border-primary/30 focus:bg-white focus:ring-4 focus:ring-primary/5"
                            }`}
                        />
                        {errors.mobile_No && (
                          <p className="text-[11px] font-bold text-red-500 mt-1.5 ml-1">{errors.mobile_No}</p>
                        )}
                      </div>
                    </div>

                    {/* Address - Full Width */}
                    <div className="md:col-span-2 space-y-2">
                      <label className="text-[13px] font-bold text-slate-700 flex items-center gap-1">
                        Physical Address <span className="text-red-500 text-[10px]">*</span>
                      </label>
                      <textarea
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        rows="3"
                        placeholder="Enter full site location details..."
                        disabled={isReadOnly}
                        className={`w-full bg-slate-50 border-2 rounded-2xl px-5 py-3 text-[14px] font-medium transition-all outline-none resize-none ${errors.address
                          ? "border-red-100 focus:border-red-400 focus:ring-4 focus:ring-red-50"
                          : "border-slate-50 focus:border-primary/30 focus:bg-white focus:ring-4 focus:ring-primary/5"
                          }`}
                      />
                      {errors.address && (
                        <p className="text-[11px] font-bold text-red-500 mt-1.5 ml-1">{errors.address}</p>
                      )}
                    </div>

                    {/* Remark */}
                    <div className="space-y-2">
                      <label className="text-[13px] font-bold text-slate-700">Internal Remarks</label>
                      <textarea
                        name="Remark"
                        value={formData.Remark}
                        onChange={handleInputChange}
                        rows="3"
                        placeholder="Additional notes for sales team..."
                        disabled={isReadOnly}
                        className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-5 py-3 text-[14px] font-medium focus:border-primary/30 focus:bg-white focus:ring-4 focus:ring-primary/5 transition-all outline-none resize-none"
                      />
                    </div>

                    {/* Sales Person */}
                    <div className="space-y-2">
                      <label className="text-[13px] font-bold text-slate-700 flex items-center gap-1">
                        Assigned Sales Person <span className="text-red-500 text-[10px]">*</span>
                      </label>
                      <Select
                        options={options}
                        value={options.find(opt => Number(opt.value) === Number(formData.sale_Person_Id)) || null}
                        isClearable
                        isSearchable
                        isDisabled={isReadOnly}
                        onChange={(opt) => setFormData(prev => ({ ...prev, sale_Person_Id: opt ? opt.value : "" }))}
                        placeholder="Choose officer..."
                        styles={customSelectStyles}
                        menuPortalTarget={document.body}
                      />
                      {errors.sale_Person_Id && (
                        <p className="text-[11px] font-bold text-red-500 mt-1.5 ml-1">{errors.sale_Person_Id}</p>
                      )}
                    </div>

                    {/* Location Link */}
                    <div className="md:col-span-2 space-y-2">
                      <label className="text-[13px] font-bold text-slate-700">Google Maps / Location Link</label>
                      <div className="relative group">
                        <input
                          type="text"
                          name="location_Link"
                          value={formData.location_Link}
                          onChange={handleInputChange}
                          placeholder="Paste G-Maps URL here..."
                          disabled={isReadOnly}
                          className="w-full bg-slate-50 border-2 border-slate-50 rounded-2xl px-5 py-3 pl-14 text-[14px] font-medium focus:border-primary/30 focus:bg-white focus:ring-4 focus:ring-primary/5 transition-all outline-none"
                        />
                        <div className="absolute left-1 top-1 w-11 h-11 bg-white rounded-xl border border-slate-100 flex items-center justify-center text-primary shadow-sm group-focus-within:bg-primary group-focus-within:text-white transition-all">
                          <RiMapPinRangeFill className="text-[20px]" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Row: Stakeholders Cards */}
            <div className="xl:col-span-4 h-full">
              <StakeholderCard
                title="Owner Information"
                icon={<IoPerson />}
                color="indigo"
                options={ownerOptions}
                value={ownerOptions.find(opt => String(opt.value) === String(formData.Owner_ID))}
                onChange={(opt) => handleEntityChange(opt, "owner", isOwnerData)}
                data={{
                  contact: formData.ownerContact,
                  email: formData.ownerEmail,
                  address: formData.ownerAddress,
                  firm: formData.ownerFirm
                }}
                isReadOnly={isReadOnly}
              />
            </div>

            <div className="xl:col-span-4 h-full">
              <StakeholderCard
                title="Architect Details"
                icon={<MdOutlineArchitecture />}
                color="emerald"
                options={architectOptions}
                value={architectOptions.find(opt => String(opt.value) === String(formData.Architect_ID))}
                onChange={(opt) => handleEntityChange(opt, "architect", isArchitectData)}
                data={{
                  contact: formData.architectContact,
                  email: formData.architectEmail,
                  address: formData.architectAddress,
                  firm: formData.architectFirm
                }}
                isReadOnly={isReadOnly}
              />
            </div>

            <div className="xl:col-span-4 h-full">
              <StakeholderCard
                title="Fabricator Details"
                icon={<FaBridgeCircleCheck />}
                color="amber"
                options={fabricatorOptions}
                value={fabricatorOptions.find(opt => String(opt.value) === String(formData.Fabricator_ID))}
                onChange={(opt) => handleEntityChange(opt, "fabricator", isFabricatorData)}
                data={{
                  contact: formData.fabricatorContact,
                  email: formData.fabricatorEmail,
                  address: formData.fabricatorAddress,
                  firm: formData.fabricatorFirm
                }}
                isReadOnly={isReadOnly}
              />
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex items-center justify-end gap-3 pt-6 border-t border-slate-200">
            <button
              type="button"
              className="px-8 py-3 bg-white border border-slate-200 text-slate-600 font-black text-xs uppercase tracking-widest rounded-2xl hover:bg-slate-50 transition-all shadow-sm"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {!isReadOnly && (
              <button
                type="submit"
                className="px-10 py-3 bg-primary text-white font-black text-xs uppercase tracking-widest rounded-2xl hover:scale-[1.02] active:scale-[0.98] transition-all shadow-[0_10px_30px_-10px_rgba(64,81,137,0.5)] border-2 border-white/10"
              >
                {isEditing ? "Update Site" : "Save Site Details"}
              </button>
            )}
          </div>
        </form>
      </div>

      <Model
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          clearModalFormData();
        }}
        name={`Add New ${currentEntityType}`}
      >
        <div className="p-2">
          <FormFields
            fields={getEntityFields(currentEntityType)}
            formData={formData}
            handleInputChange={handleInputChange}
            onSubmit={handleSubmit}
            onClear={() => setIsModalOpen(false)}
          />
        </div>
      </Model>
    </>
  );
};

// --- Custom Sub-Components & Styles ---

const StakeholderCard = ({ title, icon, color, options, value, onChange, data, isReadOnly }) => {
  const colorMap = {
    indigo: "from-indigo-500 to-indigo-600 shadow-indigo-500/20",
    emerald: "from-emerald-500 to-emerald-600 shadow-emerald-500/20",
    amber: "from-amber-500 to-amber-600 shadow-amber-500/20"
  };

  return (
    <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 overflow-hidden h-full flex flex-col transition-all hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)]">
      <div className="px-6 py-4 border-b border-slate-50 bg-slate-50/50 flex items-center gap-3">
        <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${colorMap[color]} flex items-center justify-center text-white shadow-lg`}>
          <span className="text-lg">{icon}</span>
        </div>
        <h2 className="text-[13px] font-black text-slate-800 uppercase tracking-wider">{title}</h2>
      </div>

      <div className="p-6 space-y-5 flex-1">
        <div>
          <label className="text-[11px] font-black text-slate-400 uppercase tracking-[0.1em] mb-1.5 block">Selection</label>
          <Select
            options={options}
            value={value || null}
            isClearable
            isSearchable
            onChange={onChange}
            isDisabled={isReadOnly}
            placeholder={`Select ${title.split(' ')[0]}...`}
            styles={customSelectStyles} menuPortalTarget={document.body}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="text-[11px] font-black text-slate-400 uppercase tracking-[0.1em] block">Contact</label>
            <p className="text-[13px] font-bold text-slate-700 break-all">{data.contact || "—"}</p>
          </div>
          <div className="space-y-1">
            <label className="text-[11px] font-black text-slate-400 uppercase tracking-[0.1em] block">Email ID</label>
            <p className="text-[13px] font-bold text-slate-700 truncate" title={data.email}>{data.email || "—"}</p>
          </div>
        </div>

        <div className="space-y-1">
          <label className="text-[11px] font-black text-slate-400 uppercase tracking-[0.1em] block">Firm Name</label>
          <p className="text-[13px] font-bold text-slate-700">{data.firm || "Not specified"}</p>
        </div>

        <div className="space-y-1">
          <label className="text-[11px] font-black text-slate-400 uppercase tracking-[0.1em] block">Office Address</label>
          <div className="bg-slate-50 rounded-xl p-3 min-h-[80px]">
            <p className="text-[12px] font-medium text-slate-600 italic leading-relaxed">
              {data.address || "Address details will appear here once selected..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
};

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#F8FAFC',
    borderColor: state.isFocused ? '#405189' : '#F8FAFC',
    borderWidth: '2px',
    borderRadius: '1rem',
    padding: '4px 8px',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.3s',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(64, 81, 137, 0.05)' : 'none',
    '&:hover': {
      borderColor: '#405189',
      backgroundColor: '#fff'
    }
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#94A3B8',
    fontWeight: '500'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#334155',
    fontWeight: '600'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
    borderRadius: '1.25rem',
    padding: '8px',
    border: '1px solid #F1F5F9',
    boxShadow: '0 20px 50px -12px rgba(0, 0, 0, 0.1)',
    zIndex: 9999999
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#405189'
      : state.isFocused
        ? '#F1F5F9'
        : 'transparent',
    color: state.isSelected
      ? '#fff'
      : state.data.value === 'add-new'
        ? '#405189'
        : '#475569',
    borderRadius: '0.75rem',
    fontSize: '13px',
    fontWeight: state.data.value === 'add-new' ? '800' : '600',
    padding: '10px 14px',
    cursor: 'pointer',
    marginBottom: '4px',
    '&:active': {
      backgroundColor: '#405189',
      color: '#fff'
    }
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize: '12px',
    fontWeight: '600',
    color: '#94A3B8'
  })
};

export default Details;
